import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../Screens/login";
import { PromoCode } from "../Screens/promoCode";
import { CreateAccount } from "../Screens/registerAccount";
import { Search } from "../Screens/Search";
import { NewUser } from "../Screens/newUser";
import { ExistingUser } from "../Screens/existingUser";
import { ActiveOrder } from "../Screens/activeOrder";
import { PickupOrder } from "../Screens/pickupOrder";
import { AddressSelection } from "../Screens/addressSelection";
import { PlaceOrder } from "../Screens/placeOrder";
import { ProductDetail } from "../Screens/productDetail";
import { Checkout } from "../Screens/checkout";
import { PendingPayment } from "../Screens/pendingPayment";
import PrivateRoute from "./PrivateRoutes";
import { useDispatch } from "react-redux";
import { loginUserWithToken } from "../redux/features/auth/authThunks"; // Ensure correct import
import { MainPage } from "../Screens/mainPage";
import { CateringPage } from "../Screens/cateringPage";
import { CateringOrder } from "../Screens/cateringOrder";
import CateringPackages from "../Screens/cateringPackages";
import PlaceCateringOrder from "../Screens/cateringPackageDetail";
import { CateringCheckout } from "../Screens/cateringCheckout";
import CateringOrderStatus from "../Screens/cateringOrderStatus";
import { CateringCalendarView } from "../Screens/cateringCalendarView";

const Spinner = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="spinner-border animate-spin border-4 border-t-4 border-gray-200 rounded-full w-16 h-16"></div>
  </div>
);

const AppRoutes = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      dispatch(loginUserWithToken(token))
        .then(() => setIsAuthenticated(true))
        .catch(() => setIsAuthenticated(false))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [dispatch]); // No unnecessary dependencies

  if (loading) {
    return <Spinner />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={isAuthenticated ? <Navigate to="/main-page" replace /> : <Login />}
      />

      {/* Public Routes - No Authentication Required */}
      <Route path="/catering-order-complete" element={<CateringOrderStatus />} />
      <Route path="/catering-order-failed" element={<CateringOrderStatus />} />

      <Route element={<PrivateRoute />}>
        <Route path="/main-page" element={<MainPage />} />
        <Route path="/catering-page" element={<CateringPage />} />
        <Route path="/catering-calendar" element={<CateringCalendarView />} />
        <Route path="/catering-packages" element={<CateringPackages />} />
        <Route path="/catering-package/:packageId" element={<PlaceCateringOrder />} />
        <Route path="/catering-order" element={<CateringOrder />} />
        <Route path="/catering-checkout" element={<CateringCheckout />} />
        <Route path="/search" element={<Search />} />
        <Route path="/promocode" element={<PromoCode />} />
        <Route path="/new-user" element={<NewUser />} />
        <Route path="/existing-user" element={<ExistingUser />} />
        <Route path="/active-order" element={<ActiveOrder />} />
        <Route path="/pickup-order" element={<PickupOrder />} />
        <Route path="/address-selection" element={<AddressSelection />} />
        <Route path="/place-order" element={<PlaceOrder />} />
        <Route path="/product-detail" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/pending-payment" element={<PendingPayment />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
